import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchConfirmationPhase = async (uhid_no) => {
  const response = await axios.get(`${API_BASE_URL}/get_confirmation_phase/${uhid_no}`);
  return response.data;
};

export const fetchPatientData = async (uhid_no) => {
  const response = await axios.get(`${API_BASE_URL}/get_patient/${uhid_no}`);
  return response.data;
};

export const createConfirmationPhase = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/confirmation_phase`, data);
  return response.data;
};

export const updateConfirmationPhase = async (uhid_no, data) => {
  const response = await axios.put(`${API_BASE_URL}/update_confirmation_phase/${uhid_no}`, data);
  return response.data;
};
